<template>
  <div>
    <b-row>
      <b-col>
        <div id="dnc-form">
          <Modal autoShow="false" />
          <b-form @submit.stop.prevent="onSubmit">
            <b-row>
              <div class="col-lg-6 offset-lg-3 col-sm-12">
                <p v-if="get(brand, 'content.instructions')" class="text-left lead" v-html="brand.content.instructions"/>
                <p v-else class="text-left lead">
                  Please complete this form if you would like to view your information, request to be added to our do not call list, opt-out of the sale of your personal information, or if you would like to submit a data deletion, information disclosure or data portability request.
                </p>
                <div v-if="this.$store.state.error">
                  <b-alert show variant="danger">{{ this.$store.state.errorMsg }}</b-alert>
                </div>
                <b-form-group label="" label-for="first_name">
                  <b-form-input
                    id="first_name"
                    name="first_name"
                    v-model="$v.form.first_name.$model"
                    :state="$v.form.first_name.$dirty ? !$v.form.first_name.$error : null"
                    aria-describedby="first_name_feedback"
                    placeholder="Enter your first name"
                    class="form-control"
                  ></b-form-input>

                  <b-form-invalid-feedback id="first_name_feedback">
                    This is a required field and must be at least 3 characters.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="" label-for="last_name">
                  <b-form-input
                    id="last_name"
                    name="last_name"
                    v-model="$v.form.last_name.$model"
                    :state="$v.form.last_name.$dirty ? !$v.form.last_name.$error : null"
                    aria-describedby="last_name_feedback"
                    placeholder="Enter your last name"
                  ></b-form-input>
                  <b-form-invalid-feedback id="last_name_feedback">
                    This is a required field and must be at least 2 characters.
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="" label-for="phone">
                  <b-form-input
                    id="phone"
                    name="phone"
                    type="text"
                    v-model="$v.form.phone.$model"
                    :state="$v.form.phone.$dirty ? !$v.form.phone.$error : null"
                    aria-describedby="phone_feedback"
                    placeholder="Enter your mobile phone number"
                  ></b-form-input>

                  <b-form-invalid-feedback id="phone_feedback">
                    This is a required field and must be numeric and 10 digits
                  </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="" label-for="email">
                  <b-form-input
                    id="email"
                    name="email"
                    type="email"
                    v-model="$v.form.email.$model"
                    :state="$v.form.email.$dirty ? !$v.form.email.$error : null"
                    aria-describedby="email_feedback"
                    placeholder="Enter your email address"
                  ></b-form-input>

                  <b-form-invalid-feedback id="email_feedback">
                    This is a required field and must be a valid email address.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="" label-for="verification_type">
                  <b-form-select
                    id="verification_type"
                    name="verification_type"
                    v-model="$v.form.verification_type.$model"
                    :options="form.verification_type_options">
                  </b-form-select>

                  <b-form-invalid-feedback id="verification_type">
                    This is a required field.
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-lg btn-block"
                  :disabled="$v.form.$invalid || !recaptcha">
                  Submit
                </b-button>
                <br>
                <div class="text-center recaptcha-container">
                  <vue-recaptcha
                    v-bind:sitekey="this.$store.state.google_api_key"
                    :loadRecaptchaScript="true"
                    @verify="onVerify"
                  />
                </div>
              </div>
            </b-row>
          </b-form>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <div class="col-lg-4 offset-lg-2 col-sm-12 how-it-works">
        <h5>{{get(brand, 'content.howItWorksSection.howItWorks.header') || 'How it works'}}</h5>
        <p>
          <slot name="howItWorksContent">
            First, submit your information above. We will then send a custom PIN to the verification type you selected,
            which you will need to confirm your identity. Once confirmed, we will search our system with the information
            you have provided. If your information is found in our system, you will be given these options, download the
            information we’ve collected, make a do not contact, do not sell, data deletion, data portability, or
            information disclosure request.
          </slot>
        </p>
      </div>
      <div class="col-lg-4 col-sm-12 how-it-works">
        <h5>{{get(brand, 'content.howItWorksSection.authorizedAgent.header') || 'Authorized agent requests'}}</h5>
        <p>
          <slot name="authorizedAgentContent">
            If you would like to make a request through an authorized agent, please provide us with valid written authorization executed by both parties at {{brand.contactInfo.consumerInquiriesEmail}} or {{brand.contactInfo.address}}
          </slot>
        </p>
      </div>
    </b-row>
  </div>
</template>
<script>
// import DncForm from '@/components/DncForm.vue'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, numeric, email } from 'vuelidate/lib/validators'
import brandVariables from '../mixins/brandVariables.js'
import helperFunctions from '../mixins/helperFunctions.js'
import { mapState } from 'vuex'
import VueRecaptcha from 'vue-recaptcha'
import Modal from '@/components/Modal.vue'

export default {
  components: { VueRecaptcha, Modal },
  mixins: [validationMixin, brandVariables, helperFunctions],
  data () {
    return {
      form: {
        first_name: null,
        last_name: null,
        phone: null,
        email: null,
        verification_type: 'sms',
        verification_type_selected: 'sms',
        verification_type_options: [
          { value: 'sms', text: 'SMS Verification' },
          { value: 'voice', text: 'Call Verification', disabled: true },
          { value: 'email', text: 'Email Verification', disabled: true }
        ]
      }
    }
  },
  validations: {
    form: {
      first_name: {
        required,
        minLength: minLength(3)
      },
      last_name: {
        required,
        minLength: minLength(2)
      },
      phone: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10)
      },
      email: {
        required,
        email
      },
      verification_type: {
        required
      }
    }
  },
  computed: mapState([
    'recaptcha', 'loading'
  ]),
  methods: {
    onSubmit () {
      this.$store.commit('setError', false)
      let trustedFormToken = document.querySelector('#xxTrustedFormToken_0').value ? document.querySelector('#xxTrustedFormToken_0').value : document.querySelector('#xxTrustedFormCertUrl_0').value
      this.$v.form.$touch()

      if (this.$store.state.recaptcha !== true) {
        this.onVerify() // Fires recaptcha verify event
      }

      if (this.$v.form.$anyError || this.$store.state.recaptcha === false) {
        return false
      }

      // Store PII in state
      this.$store.commit('storePii', {
        data: this.$v.form.$model,
        trustedFormToken: trustedFormToken
      })

      // dispatching login action which is posting
      this.$store.dispatch('loginAction', {
        payload: this.$v.form.$model,
        trustedFormToken: trustedFormToken
      })
    },
    onVerify: function (response) {
      if (typeof response === 'undefined' && response !== '') {
        this.$store.commit('recaptcha', false)
      } else {
        this.$store.commit('recaptcha', true)
      }
    }
  }
}
</script>
<style lang="less">
  #dnc-form {
    .lead {
      font-size: 1.15rem;
    }
    .form-group {}
    text-align: center;
    label {
      text-align: left;
    }
    .recaptcha-container {
      div {
        text-align: center;
        margin: 0 auto;
      }
    }
  }
  .dev {
    text-align: left;
  }
  .how-it-works {
    h5 {
      text-align: left;
      text-transform: uppercase;
      font-weight: bold;
    }
    p {
      font-size: 13px;
      line-height: 24px;
    }
  }
</style>
